import Constants from 'config/constants';
import Dispatcher from 'lib/dispatcher';

export default {
  logout() {
    Dispatcher.handleAppAction({ actionType: Constants.LOGOUT });
  },

  UpdateQueryString(key, value, url) {
    if (!url) url = window.location.href;
    const re = new RegExp(`([?&])${key}=.*?(&|#|$)(.*)`, 'gi');
    let hash;

    if (re.test(url)) {
      if (typeof value !== 'undefined' && value !== null) {
        let newUrl = url.replace(re, `$1${key}=${value}$2$3`);
        if (newUrl === url) {
          newUrl += `&${key}=${value}`;
        }
        return newUrl;
      }
      hash = url.split('#');
      url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
      if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
        url += `#${hash[1]}`;
      }
      return url;
    }

    if (typeof value !== 'undefined' && value !== null) {
      const separator = url.indexOf('?') !== -1 ? '&' : '?';
      hash = url.split('#');
      url = `${hash[0] + separator + key}=${value}`;
      if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
        url += `#${hash[1]}`;
      }
      return url;
    }
    return url;
  },
  docHeight() {
    const { body } = document;
    const html = document.documentElement;

    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );
    return docHeight;
  },
};
